/* eslint no-unused-vars: 0  */
/* global $, Cookies */
$(document).ready(() => {
  $.$body.find('.video-popup').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
  });

  $.$body.find('.popup-youtube').magnificPopup({
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
  });

  $.$body.find("a[class*='popup-link-']").magnificPopup({
    type: 'inline',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: true,
    closeMarkup:
      '<button title="Close (Esc)" type="button" class="popup-close mfp-close"><svg x="0px" y="0px" viewBox="0 0 56 56" style="enable-background:new 0 0 56 56;" xml:space="preserve"><path d="M27.9,0c15.5,0,27.9,12.5,27.9,27.9c0,15.5-12.5,27.9-27.9,27.9C12.5,55.8,0,43.3,0,27.9C0,12.5,12.5,0,27.9,0z M27.9,24.6l11.5-11.5l3.3,3.3L31.1,27.9l11.5,11.5l-3.3,3.3L27.9,31.1L16.4,42.6l-3.3-3.3l11.5-11.5L13.1,16.4l3.3-3.3L27.9,24.6z M27.9,1.3C13.2,1.3,1.3,13.2,1.3,27.9c0,14.7,11.9,26.5,26.5,26.5c14.7,0,26.5-11.8,26.5-26.5C54.4,13.2,42.6,1.3,27.9,1.3z"/></svg></button>',
  });

  $.$body.find("a[class*='popup-witness-link-']").magnificPopup({
    type: 'inline',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: true,
    closeMarkup:
      '<button title="Close (Esc)" type="button" class="popup-close mfp-close"><svg x="0px" y="0px" viewBox="0 0 56 56" style="enable-background:new 0 0 56 56;" xml:space="preserve"><path d="M27.9,0c15.5,0,27.9,12.5,27.9,27.9c0,15.5-12.5,27.9-27.9,27.9C12.5,55.8,0,43.3,0,27.9C0,12.5,12.5,0,27.9,0z M27.9,24.6l11.5-11.5l3.3,3.3L31.1,27.9l11.5,11.5l-3.3,3.3L27.9,31.1L16.4,42.6l-3.3-3.3l11.5-11.5L13.1,16.4l3.3-3.3L27.9,24.6z M27.9,1.3C13.2,1.3,1.3,13.2,1.3,27.9c0,14.7,11.9,26.5,26.5,26.5c14.7,0,26.5-11.8,26.5-26.5C54.4,13.2,42.6,1.3,27.9,1.3z"/></svg></button>',
  });

  const $popOver = $.$body.find('.pop-over');

  // Modal Popups. Global/page using Magnific Popup plugin.
  //----------------------------------------------------------------------------
  if ($popOver.length > 0) {
    /**
     * Depending on the type of modal used (if any), initializes it
     * accordingly.
     *
     * @return {void}
     */
    const initializeModal = () => {
      // console.log('show Modalal');
      $popOver.find('[data-src]').each((i, el) => {
        const $img = $(el);
        $img.attr('src', $img.data('src'));
      });
      $popOver.addClass('is-visible');
      if ($popOver.hasClass('image')) {
        // Image modal.
        const $imagePopup = $.$body.find('#image-popup');
        if ($imagePopup.length > 0) {
          $imagePopup.magnificPopup({
            type: 'image',
            closeOnContentClick: true,
            mainClass: 'mfp-img-mobile',
            image: {
              verticalFit: true,
            },
            callbacks: {
              open: () => {
                $('body').removeClass('is-splashed');
              },
            },
          });
          $imagePopup.click();
        } else {
          $.$body.find('#image-popup-linkable').magnificPopup({
            type: 'inline',
            preloader: false,
            callbacks: {
              open: () => {
                $('body').removeClass('is-splashed');
              },
            },
          });
          $.$body.find('#image-popup-linkable').click();
        }
      } else if ($popOver.hasClass('video')) {
        // console.log('video modal');
        const isAutoPlay = $('.pop-over.video .play-row').data('autoplay');
        // Video modal.
        $.$body.removeClass('is-splashed');
        if (!isAutoPlay) {
          $popOver.on('click', () => {
            // console.log('clicked .pop-over');
            $('.pop-over.video').fadeOut();
          });
        }
        // $popOver.find('.video-play-bg').on('click touchstart', e => {
        //   console.log('clicked .video-play-bg');
        //   e.preventDefault();
        //   e.stopPropagation();
        //   e.stopImmediatePropagation();
        //   // $popOver.find('[data-fancybox]').click();
        // });
        $popOver.find('[data-fancybox]').on('touchstart', (e) => {
          // console.log('clicked fancy');
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          $popOver.find('[data-fancybox]').click();
        });
        if (isAutoPlay === true) {
          $popOver.find('[data-fancybox]').click();
        }
      } else if ($popOver.hasClass('html')) {
        // HTML modal.
        const $inlinePopupLink = $.$body.find('#inline-popup-link');
        $inlinePopupLink.magnificPopup({
          type: 'inline',
          preloader: false,
          callbacks: {
            open: () => {
              $.$body.removeClass('is-splashed');
            },
          },
        });
        $inlinePopupLink.click();
      } else if ($popOver.hasClass('bsd')) {
        // BSD modal.
        const $bsdPopupLink = $.$body.find$('#bsd-popup-link');
        $bsdPopupLink.magnificPopup({
          type: 'inline',
          preloader: false,
          callbacks: {
            open: () => {
              $.$body.removeClass('is-splashed');
            },
          },
        });
        $bsdPopupLink.click();
      }
    };

    // Show or don't show modal based on cookie logic.
    const $popupOptions = $.$body.find('.js-popup-options');
    const frequency = $popupOptions.data('frequency');
    const cookieName = $popupOptions.data('cookie-name');
    if (!Cookies.getJSON(cookieName) || frequency === 'always') {
      initializeModal();
      if (frequency !== 'always') {
        if (frequency === 'session') {
          Cookies.set(cookieName, 'shown');
        } else {
          const cookieLengths = {
            week: 7,
            once: 999,
          };
          Cookies.set(cookieName, 'shown', {
            expires: cookieLengths[frequency],
          });
        }
      }
    }
  }
});
